import {useDataProductForm} from "../useDataProductForm";
import React, {useEffect} from "react";
import {ExtractGeneralForm} from "./ExtractGeneralForm";
import DevicesForm from "../DevicesForm";
import ZonesAssociationForm from "../../zones/ZonesAssociationForm";
import {ExtractMonitor} from "./ExtractMonitor";
import AggregationForm from "../AggregationForm";
import {Tabs, Yup} from "../../components";
import {Form} from "react-bootstrap";
import AudienceFilterForm from "../AudienceFilterForm";
import { formatDate } from "../../Format";

export default function ExtractForm({extract, disabled, handleSubmit, tabProps, audiences, aggregationOptions, bucket, setSubmitButtonProps, errors}) {

  const defaultStartDateTest = (context, value) => {
    const limitDate = new Date('2022-01-01')
    if (new Date(value) > limitDate) {
      return true;
    } else {
      return context.createError({
        path: context.path,
        message: `data cannot be extract before ${formatDate(limitDate)}`,
      });
    }
  }

  const snappedDateStartDateTest = (context, value) => {
    const limitDate = new Date('2023-03-01')
    if (new Date(value) > limitDate ) {
      return true;
    } else {
      return context.createError({
        path: context.path,
        message: `snapped_traces cannot be extract before ${formatDate(limitDate)}`,
      });
    }
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    start_date: Yup.string().required().when('data_type',{
      is: (value) => value == 'snapped_traces',
      then: (schema) => schema.test('snapped_traces-start-date', function(value) {
        return snappedDateStartDateTest(this, value)
      }),
      otherwise: (schema) => schema.test('default-start-date', function(value) {
        return defaultStartDateTest(this, value)
      })
    }),
    end_date: Yup.string().required(),
    aggregate: Yup.object().when('use_aggregate', {
      is: true,
      then: Yup.object().required()
    })
  })

  const initialValues = {
    aggregate: {},
    audience_scope: {}
  }

  const {formData, setFormData, getInputProps, formProps, useParentFormRef, setDisabled} = useDataProductForm({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
    setSubmitButtonProps: setSubmitButtonProps,
    errors
  })

  useEffect(() => {
    setDisabled(disabled)
  }, [disabled])

  useEffect(() => {
    setFormData(extract)
  }, [extract])

  return (
    <>
      <Form {...formProps}/>
      <Tabs {...tabProps}>
        <ExtractGeneralForm
          formData={formData}
          getInputProps={getInputProps}
          disabled={disabled}
          bucket={bucket}
          as="extract"
          icon="stream"
          useParentFormRef={useParentFormRef}
        />
        <DevicesForm
          formData={formData}
          getInputProps={getInputProps}
          disabled={disabled}
          as="devices"
          icon="mobile"
        />
        <ZonesAssociationForm
          formData={formData}
          getInputProps={getInputProps}
          disabled={disabled}
          useParentFormRef={useParentFormRef}
          as="geography"
          icon="target"
        />
        <AggregationForm
          icon="sum"
          as="aggregate"
          aggregate={formData.aggregate}
          aggregationOptions={aggregationOptions}
          dataType={formData.data_type}
          disabled={disabled}
          parentFormRef={useParentFormRef("aggregate")}
        />
        <AudienceFilterForm
          icon="audience"
          as="audience_scope"
          disabled={disabled}
          audience_scope={formData.audience_scope}
          audiences={audiences}
          parentFormRef={useParentFormRef("audience_scope")}
        />
        <ExtractMonitor
          extract={extract}
          icon="target"
          hide={!extract || extract.key === undefined}
          as="extract_monitor"
        />
      </Tabs>
    </>
  )
}
